import { React, useEffect, useState } from "react";
import { useParams} from "react-router-dom";
import { toast } from "react-toastify";

import { getAvailableUsersForDelegation, addCustomerDelegatedUser, getCustomerDelegatedUsers } from "../utils/Api";
import { handleLoaderEvent } from "../utils/LoaderEmitter";

import Select from "react-select";
import ReactPaginate from "react-paginate";

import EditDelegatedUser from "./EditDelegatedUser";
import ClientNavigation from "./ClientNavigation";

import { Image } from "@fluentui/react-northstar";
import { Modal } from "react-bootstrap";
import { iconAssets } from "../assets/theme/theme";

import "../styles/ViewUsers.css";

const DelegatedUser = () => {
  const [addModalShow, setAddModalShow] = useState(false);
  const [customerDelegatedUsers, setCustomerDelegatedUsers] = useState([]);
  const [itemsPerPage, setitemsPerPage] = useState(5);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentItems, setCurrentItems] = useState();
  const [delegatedUserApiResponse, setDelegatedUserApiStatus] = useState(false);
  const [availableUsersForDelegation, setAvailableUsersForDelegation] = useState();
  const [selectedCustomerDelegatedUser, setSelectedCustomerDelegatedUser] = useState();

  let { id } = useParams();

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(customerDelegatedUsers?.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(customerDelegatedUsers?.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, customerDelegatedUsers]);

  useEffect(() => {
    (async () => {
      handleLoaderEvent.emit("loader", true);
      let users = await getAvailableUsersForDelegation();
      let delegatedUsersOptions = [];
      users.forEach((user) => {
        delegatedUsersOptions.push({ value: user.id, label: user.first_name + " " + user.last_name });
      });
      setAvailableUsersForDelegation(delegatedUsersOptions);

      let delegatedUsers = await getCustomerDelegatedUsers(id);
      setCustomerDelegatedUsers(delegatedUsers);
      handleLoaderEvent.emit("loader", false);
    })();
  }, [delegatedUserApiResponse]);

  const addModalHandleClose = () => setAddModalShow(false);

  const addModalHandleShow = () => {
    setAddModalShow(true);
  };

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % customerDelegatedUsers.length;
    setItemOffset(newOffset);
  };

  const saveDelegatedUser = async () => {
    let response = await addCustomerDelegatedUser(id, selectedCustomerDelegatedUser);
    if (response) {
      setDelegatedUserApiStatus((prev) => !prev);
      addModalHandleClose();
      handleLoaderEvent.emit("loader", true);
      toast.info("Delegated user added successfully");
    }
  };

  const userRows = (currentItems) =>
    currentItems?.map((user) => {
      return (
        <>
          <EditDelegatedUser key={user.id} user={user} setDelegatedUserApiStatus={setDelegatedUserApiStatus}></EditDelegatedUser>
        </>
      );
    });

  const userTable = () => {
    return (
      <>
        <table className="container-fluid p-0">
          <thead>
            <tr className="mb-4 table-header">
              <th style={{ width: "15%" }}>First Name</th>
              <th style={{ width: "15%" }}>Last Name</th>
              <th style={{ width: "20%" }}>Email</th>
              <th style={{ width: "40%" }}>Actions</th>
            </tr>
          </thead>
          <tbody>{userRows(currentItems)}</tbody>
        </table>
      </>
    );
  };
  const onDelegatedUserSelection = async (userId) => {
    let params = {
      user_id: userId,
    };
    setSelectedCustomerDelegatedUser(params);
  };

  return (
    <>
      <ClientNavigation id={id} selectedTab={"Manage Delegation"}></ClientNavigation>
      <div className="row p-0 m-0 screen-header mt-4 mb-3 p-1">
        <div className="col content-title ps-4">Delegated Users</div>
        <div className="col-auto cursor" onClick={() => addModalHandleShow()}>
          <div className="row p-0 m-0 cursor-pointer">
            <div className="col-auto pe-1 d-flex align-items-center">
              <Image src={iconAssets.add} alt="" className="add-icon" />
            </div>
            <div className="col-auto ps-0 content-title-sub-text d-flex align-items-center">Add Delegated User</div>
          </div>
        </div>
      </div>
      <div className="user-table">{userTable(customerDelegatedUsers)}</div>
      <div className="row p-0 m-0 mt-4">
        <div className="col-auto px-2 d-flex align-items-center">Rows Per Page</div>
        <div className="col-auto px-2 d-flex align-items-center">
          <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
            {itemsPerPage}
          </button>
          <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <div className="dropdown-item" onClick={() => setitemsPerPage(5)}>
                5
              </div>
            </li>
            <li>
              <div className="dropdown-item" onClick={() => setitemsPerPage(10)}>
                10
              </div>
            </li>
          </ul>
        </div>
        <div className="col p-0 d-flex justify-content-end">
          <ReactPaginate
            nextLabel=">"
            onPageChange={handlePageClick}
            pageRangeDisplayed={4}
            marginPagesDisplayed={2}
            pageCount={pageCount}
            previousLabel="<"
            pageClassName="page-item"
            pageLinkClassName="page-link"
            previousClassName="page-item"
            previousLinkClassName="page-link"
            nextClassName="page-item"
            nextLinkClassName="page-link"
            breakLabel="..."
            breakClassName="page-item"
            breakLinkClassName="page-link"
            containerClassName="pagination"
            activeClassName="active"
            renderOnZeroPageCount={null}
          />
        </div>
      </div>
      <Modal className="edit-modal" show={addModalShow} onHide={addModalHandleClose}>
        <Modal.Body>
          <Modal.Title>Add Delegated User</Modal.Title>
          <div className="container mt-3">
            <Select isClearable="true" isSearchable="true" onChange={(e) => onDelegatedUserSelection(e.value)} options={availableUsersForDelegation} />
            <div className="d-flex justify-content-center mt-5">
              <button type="button" className="cancel-button p-2 px-4 me-3" onClick={addModalHandleClose}>
                Cancel
              </button>
              <button type="submit" className="save-button p-2 px-4" onClick={saveDelegatedUser}>
                Save
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default DelegatedUser;
